// Script to initialise the auto complete jQuery Plugin for the search input field

jQuery(document).ready( function($) {
  var url = WPURLS.autocompleteurl + "?action=autocomplete_search";
  $('.autocomplete-search').autocomplete({
    source: url,
    delay: 500,
    minLength: 3
  });
});
jQuery(document).ready( function($) {
  var url = WPURLS.autocompleteurl + "?action=autocomplete_region";
  $('.autocomplete-region').autocomplete({
    source: url,
    delay: 500,
    minLength: 3
  });
});